import {
  FETCH_DELETE_ROLES_REQUEST,
  FETCH_DELETE_ROLES_SUCCESS,
  FETCH_DELETE_ROLES_FALUIRE,
} from './deleteRolesTypes'

const initialState = {
  loading: false,
  deleteRolesdInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_ROLES_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_ROLES_SUCCESS : return {
      ...state,
      deleteRolesInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_ROLES_FALUIRE : return {
      ...state,
      loading: false,
      deleteRolesInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
